module.exports = __webpack_public_path__ + "img/chipping1.9b1f1d88.png";